import {useIntl} from 'react-intl'
import {LineAreaChart} from '../components'
import {dataToSeries} from '../../utility'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {currency} from 'src/feature/bite/helpers/currency'

export default function AverageAnalytics({
  member,
  average,
  period,
}: {
  member?: {
    activeMemberChartData: {date: string; value: number}[]
    activeMemberCount: number
    clv: number
    loyaltyMemberChartData: {date: string; value: number}[]
    loyaltyMemberCount: number
    newMembersJoinedChartData: {date: string; value: number}[]
    newMembersJoinedCount: number
    referralCustomersAcquiredChartData: {date: string; value: number}[]
    referralCustomersAcquiredCount: number
  }
  average?: {
    averageNumberOfProducts: number
    averageOrderFrequency: number
    averageOrderSize: number
    averagePointsEarnedPerOrder: number
  }
  period?: string
}) {
  const intl = useIntl()

  return (
    <>
      <div className='row'>
        <div className='col-12 col-md-4 mt-5 mt-md-0 position-relative'>
          <div className='card h-100 position-relative'>
            <div className='w-100 p-5'>
              <div className='row'>
                <div className='col-8 text-extra-purple fs-2 fw-bold'>
                  {member?.loyaltyMemberCount || 0}
                </div>
                <div className='col-4 text-extra-purple fs-2 fw-bold'>
                  {currency(member?.clv || 0)}
                </div>
                <div className='col-8 fs-2 position-relative'>
                  {intl.formatMessage({id: 'ANALYTICS.LOYALTY_MEMBER'})}
                  <span className='position-relative z-50'>
                    <OverlayTrigger
                      placement='top'
                      overlay={
                        <Tooltip>
                          {intl.formatMessage(
                            {id: 'ANALYTICS.LOYALTY_MEMBER_TOOLTIP'},
                            {time: period}
                          )}
                        </Tooltip>
                      }
                    >
                      <i className='bi bi-info-circle text-primary ms-1'></i>
                    </OverlayTrigger>
                  </span>
                </div>
                <div className='col-4 fs-2'>
                  {intl.formatMessage({id: 'ANALYTICS.CLV'})}
                  <span className='position-relative'>
                    <OverlayTrigger
                      placement='top'
                      overlay={
                        <Tooltip>
                          {intl.formatMessage({id: 'ANALYTICS.CLV_TOOLTIP'}, {time: period})}
                        </Tooltip>
                      }
                    >
                      <i className='bi bi-info-circle text-primary ms-1'></i>
                    </OverlayTrigger>
                  </span>
                </div>
              </div>
            </div>
            <div className='position-relative w-100 h-100'>
              <LineAreaChart
                data={dataToSeries(
                  intl.formatMessage({id: 'ANALYTICS.LOYALTY_MEMBER'}),
                  member?.loyaltyMemberChartData || []
                )}
              />
            </div>
          </div>
        </div>
        <div className='col-12 col-md-4 mt-5 mt-md-0 position-relative'>
          <div className='card h-350px position-relative'>
            <div className='w-100 p-5'>
              <div className='row'>
                <div className='col-12 text-extra-purple fs-2 fw-bold'>
                  {member?.activeMemberCount || 0}
                </div>
                <div className='col-12 fs-2'>
                  {intl.formatMessage({id: 'ANALYTICS.ACTIVE_MEMBER'})}
                  <span className='position-relative'>
                    <OverlayTrigger
                      placement='top'
                      overlay={
                        <Tooltip>
                          {intl.formatMessage(
                            {id: 'ANALYTICS.ACTIVE_MEMBER_TOOLTIP'},
                            {time: period}
                          )}
                        </Tooltip>
                      }
                    >
                      <i className='bi bi-info-circle text-primary ms-1'></i>
                    </OverlayTrigger>
                  </span>
                </div>
              </div>
            </div>
            <div className='position-relative w-100 h-100'>
              <LineAreaChart
                data={dataToSeries(
                  intl.formatMessage({id: 'ANALYTICS.ACTIVE_MEMBER'}),
                  member?.activeMemberChartData || []
                )}
              />
            </div>
          </div>
        </div>
        <div className='col-12 col-md-4 mt-5 mt-md-0 position-relative'>
          <div className='card h-350px position-relative'>
            <div className='w-100 p-5'>
              <div className='row'>
                <div className='col-12 text-extra-purple fs-2 fw-bold'>
                  {member?.newMembersJoinedCount || 0}
                </div>
                <div className='col-12 fs-2'>
                  {intl.formatMessage({id: 'ANALYTICS.NEW_MEMBERS_JOINED'})}
                  <span className='position-relative'>
                    <OverlayTrigger
                      placement='top'
                      overlay={
                        <Tooltip>
                          {intl.formatMessage(
                            {id: 'ANALYTICS.NEW_MEMBERS_JOINED_TOOLTIP'},
                            {time: period}
                          )}
                        </Tooltip>
                      }
                    >
                      <i className='bi bi-info-circle text-primary ms-1'></i>
                    </OverlayTrigger>
                  </span>
                </div>
              </div>
            </div>
            <div className='position-relative w-100 h-100'>
              <LineAreaChart
                data={dataToSeries('New members joined', member?.newMembersJoinedChartData || [])}
              />
            </div>
          </div>
        </div>
        {/* <div className='col-12 col-md-3 mt-5 mt-md-0 position-relative'>
          <div className='card h-350px position-relative'>
            <div className='w-100 p-5'>
              <div className='row'>
                <div className='col-12 text-extra-purple fs-2 fw-bold'>
                  {member?.referralCustomersAcquiredCount || 0}
                </div>
                <div className='col-12 fs-2'>
                  {intl.formatMessage({ id: 'ANALYTICS.REFERRAL_CUSTOMERS_ACQUIRED' })}
                  <span className='position-relative'>
                    <OverlayTrigger
                      placement='left'
                      overlay={
                        <Tooltip>
                          {intl.formatMessage({ id: 'ANALYTICS.REFERRAL_CUSTOMERS_ACQUIRED_TOOLTIP' }, { time: period })}
                        </Tooltip>
                      }
                    >
                      <i className='bi bi-info-circle text-primary ms-1'></i>
                    </OverlayTrigger>
                  </span>
                </div>
              </div>
            </div>
            <div className='position-relative w-100 h-100'>
              <LineAreaChart
                data={dataToSeries(
                  intl.formatMessage({ id: 'ANALYTICS.REFERRAL_CUSTOMERS_ACQUIRED' }),
                  member?.referralCustomersAcquiredChartData || []
                )}
              />
            </div>
          </div>
        </div> */}
      </div>

      <div className='row mt-5'>
        <div className='col-12 col-md-3 mt-5 mt-md-0 position-relative'>
          <div className='card' style={{minHeight: '135px'}}>
            <div className='w-100 p-5'>
              <div className='d-flex flex-column gap-3'>
                <div className='text-extra-purple fs-2 fw-bold'>
                  {currency(average?.averageOrderSize || 0)}
                </div>
                <div className='fs-2'>
                  {intl.formatMessage({id: 'ANALYTICS.AVG_ORDER_SIZE'})}
                  <span className='position-relative'>
                    <OverlayTrigger
                      placement='top'
                      overlay={
                        <Tooltip>
                          {intl.formatMessage(
                            {id: 'ANALYTICS.AVG_ORDER_SIZE_TOOLTIP'},
                            {time: period}
                          )}
                        </Tooltip>
                      }
                    >
                      <i className='bi bi-info-circle text-primary ms-1'></i>
                    </OverlayTrigger>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='col-12 col-md-3 mt-5 mt-md-0 position-relative'>
          <div className='card' style={{minHeight: '135px'}}>
            <div className='w-100 p-5'>
              <div className='d-flex flex-column gap-3'>
                <div className='text-extra-purple fs-1 fw-bold'>
                  {average?.averageNumberOfProducts || 0}
                </div>
                <div className='fs-2'>
                  {intl.formatMessage({id: 'ANALYTICS.AVG_NUMBER_OF_PRODUCTS_IN_THE_ORDER'})}
                  <span className='position-relative'>
                    <OverlayTrigger
                      placement='top'
                      overlay={
                        <Tooltip>
                          {intl.formatMessage(
                            {id: 'ANALYTICS.AVG_NUMBER_OF_PRODUCTS_IN_THE_ORDER_TOOLTIP'},
                            {time: period}
                          )}
                        </Tooltip>
                      }
                    >
                      <i className='bi bi-info-circle text-primary ms-1'></i>
                    </OverlayTrigger>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='col-12 col-md-3 mt-5 mt-md-0 position-relative'>
          <div className='card' style={{minHeight: '135px'}}>
            <div className='w-100 p-5'>
              <div className='d-flex flex-column gap-3'>
                <div className='text-extra-purple fs-1 fw-bold'>
                  {average?.averageOrderFrequency || 0}
                </div>
                <div className='fs-2'>
                  {intl.formatMessage({id: 'ANALYTICS.AVG_ORDER_FREQUENCY'})}
                  <span className='position-relative'>
                    <OverlayTrigger
                      placement='top'
                      overlay={
                        <Tooltip>
                          {intl.formatMessage(
                            {id: 'ANALYTICS.AVG_ORDER_FREQUENCY_TOOLTIP'},
                            {time: period}
                          )}
                        </Tooltip>
                      }
                    >
                      <i className='bi bi-info-circle text-primary ms-1'></i>
                    </OverlayTrigger>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='col-12 col-md-3 mt-5 mt-md-0 position-relative'>
          <div className='card' style={{minHeight: '135px'}}>
            <div className='w-100 p-5'>
              <div className='d-flex flex-column gap-3'>
                <div className='text-extra-purple fs-1 fw-bold'>
                  {average?.averagePointsEarnedPerOrder || 0}
                </div>
                <div className='col-11 fs-2'>
                  {intl.formatMessage({id: 'ANALYTICS.AVG_POINTS_EARNED_PER_ORDER'})}
                  <span className='position-relative'>
                    <OverlayTrigger
                      placement='top'
                      overlay={
                        <Tooltip>
                          {intl.formatMessage(
                            {id: 'ANALYTICS.AVG_POINTS_EARNED_PER_ORDER_TOOLTIP'},
                            {time: period}
                          )}
                        </Tooltip>
                      }
                    >
                      <i className='bi bi-info-circle text-primary ms-1'></i>
                    </OverlayTrigger>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className='separator my-10'
        style={{
          borderBottom: '2px solid rgba(217, 219, 228, 0.5)',
        }}
      ></div>
    </>
  )
}
